module.exports = __webpack_public_path__ + "2216f96dece3c8284e665f5a127c20bf.png";